import axios from 'axios';
const uuidv4 = require('uuid/v4');
export default({
    data(){
        return {
            isUploadingInProgress: false,
            attachment_file:"",
            download_url:"",
            check_attachments: false,
            input_file:[],
            input_file_inside:[],
        }
    },
    methods: {
        uploadAttachment(event) {
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                this.attachments.push(attachment)
                this.getResumableURL(input[0].file, this.attachments[this.attachments.length - 1]);
            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.attachments.push(attachment)
                this.getResumableURL(input.files[0], this.attachments[this.attachments.length - 1]);
            }
        },
        getResumableURL(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
            })
            .catch(error => {
                console.log(error.data.reason)
            })
        },
        uploadFileToUpload(resumable_url, file, attachment) {
            axios.post("https://cloudapis.digicollect.com/external/upload_file", file, {
                    headers: {
                        Authorization: this.$http.defaults.headers.common.Authorization = this.$cookie.get('Token')
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                        if (progress < 100) {
                            attachment.progress = progress;
                        }
                    }.bind(this)
                })
                .then(() => {
                    attachment.progress = 100;
                    attachment.uploading = false;
                    this.isUploadingInProgress = false;
                    delete attachment['source'];
                })
                .catch(error => {
                    console.log(error.data.reason)
                    this.error = "Error Uploading"
                })
        },
        downloadAttachment(attachment){
            this.download_url = attachment.url
            var a = document.createElement('a');
            a.href = this.download_url;
            a.download = attachment.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        uploadAttachmentSingle(event){
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                this.singleAttachment = attachment
                this.getResumableURL(input.files[0], this.singleAttachment);
            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.singleAttachment = attachment
                this.getResumableURL(input.files[0], this.singleAttachment);
            }
        },
        uploadAttachmentSingleNew(event){
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                this.singleAttachmentNew = attachment
                this.getResumableURL(input.files[0], this.singleAttachmentNew);
            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.singleAttachmentNew = attachment
                this.getResumableURL(input.files[0], this.singleAttachmentNew);
            }
        },
        getResumableInsideURL(file, attachment) {
            this.isUploadingInProgress = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            axios.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                headers: {
                    Authorization: this.$http.defaults.headers.common.Authorization = this.$cookie.get('Token')
                }
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.uploading = true;
                this.uploadFileToUpload(resumable_url,file,attachment)
                if (response.data.hasOwnProperty('reason')){
                    attachment.error = "Error Uploading"
                    if (attachment.url == undefined) {
                        this.check_attachments = true
                    } else {
                        this.check_attachments = false
                    }
                }
                this.isUploadingInProgress = false;
            })
            .catch(error => {
                console.log(error.data.reason)
                // this.error = "Error Uploading"
            })
        },
        uploadAttachmentOutsideFromDrop(event) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.attachments.push(attachment)
                this.getResumableURL(input, this.attachments[this.attachments.length - 1]);
            }
        },
        uploadAttachmentInsideFromDrop(event) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.attachments_inside.push(attachment)
                this.getResumableInsideURL(input, this.attachments_inside[this.attachments_inside.length - 1]);
            }
        },
        uploadAttachmentInside(event) {
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload_inside.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                this.attachments_inside.push(attachment)
                this.getResumableInsideURL(input[0].file, this.attachments_inside[this.attachments_inside.length - 1]);

            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.attachments_inside.push(attachment)
                this.getResumableInsideURL(input.files[0], this.attachments_inside[this.attachments_inside.length - 1]);
            }
        },
    },
    computed:{
        error(){
            return ""
        }
    },
})
